///<amd-module name="typeahead/core/message/SuggestionAutoSelectedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {Suggestion} from "typeahead/core/Suggestion";

export class SuggestionAutoSelectedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.suggestion_auto_selected";
    }

    private suggestion: Suggestion;
    private domElementId: string;

    constructor(suggestion: Suggestion, domElementId: string) {
        this.suggestion = suggestion;
        this.domElementId = domElementId;
    }

    public getTopic(): string {
        return SuggestionAutoSelectedMessage.getTopic();
    }

    public getSuggestion(): Suggestion {
        return this.suggestion;
    }

    public getDomElementId(): string {
        return this.domElementId;
    }
}
